export const CHANGE_MENU_PATH = 'CHANGE_MENU_PATH';

export function changeMenuPath(name, path) {
  sessionStorage.setItem(name, path);

  return {
    type: CHANGE_MENU_PATH,
    payload: { name, path },
  };
}
